import { render, staticRenderFns } from "./Question63.vue?vue&type=template&id=01621eea&scoped=true&"
import script from "./Question63.vue?vue&type=script&lang=js&"
export * from "./Question63.vue?vue&type=script&lang=js&"
import style0 from "./Question63.vue?vue&type=style&index=0&id=01621eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01621eea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VSimpleTable})
